module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-calendar-list"
  }, [_c('div', {
    staticClass: "d-calendar-list__header",
    class: {
      'd-calendar-list__header--flex': _vm.isCalendarInPrintMode
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dateRangeFormatted))])]), _vm._v(" "), _c('table', [_c('tbody', [(_vm.eventsSortedInDays.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer pad-1"
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['no_lessons']) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsSortedInDays), function(event) {
    return _c('tr', {
      key: event.id,
      class: {
        'tr--is-day': event.type && event.type === 'dayDate'
      }
    }, [(event.type && event.type === 'dayDate') ? [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', [_c('p', [_vm._v(_vm._s(event.showDay))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.showDate))])])])] : [_c('td', [_c('div', {
      staticClass: "lesson"
    }, [_vm._v("\n            " + _vm._s(event.v_start) + " - " + _vm._s(event.v_end) + "\n            "), _c('div', {
      staticClass: "lesson__dot",
      style: ({
        'backgroundColor': event.color
      })
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.title)), (event.group.length > 0) ? [_vm._v(", " + _vm._s(event.group))] : _vm._e()], 2)])]), _vm._v(" "), _c('td', [(event.teacher.length > 0) ? _c('span', {
      staticClass: "icon-user"
    }) : _vm._e(), _vm._v(" " + _vm._s(event.teacher) + "\n        ")]), _vm._v(" "), _c('td', [(event.substitutes.length > 0) ? _c('span', {
      staticClass: "icon-users3"
    }) : _vm._e(), _vm._v(" " + _vm._s(event.substitutes) + "\n        ")]), _vm._v(" "), _c('td', [(event.room.length > 0) ? _c('span', {
      staticClass: "icon-location"
    }) : _vm._e(), _vm._v(" " + _vm._s(event.room) + "\n        ")])]], 2)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15649ecc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarList.vue
// module id = 1525
// module chunks = 1